
import dust from "dustjs-linkedin";


(function(){dust.register("grammar-tips/no-favorites",body_0);function body_0(chk,ctx){return chk.write("<section class=\"no-favorites\"><div class=\"huge-star\"></div><h3>").helper("i18n",ctx,{},{"id":"grammar_tips_no_favorites_heading"}).write("</h3><p class=\"subheading\">").helper("i18n",ctx,{},{"id":"grammar_tips_no_favorites_subheading"}).write("</p><article>").helper("i18n",ctx,{},{"id":"grammar_tips_no_favorites_content","img_star":"<img src='../img/fav-checked.svg'>"}).write("</article></section>");}return body_0;})();

export default 0;
